import { createEvent, createStore, StoreWritable } from 'effector'

type State = {
  isOpen: boolean
}

class FinishCallModalService {
  readonly open = createEvent<void>()
  readonly close = createEvent<void>()

  readonly store: StoreWritable<State>

  constructor() {
    this.store = createStore<State>({ isOpen: false })
      .on(this.open, (s) => ({ ...s, isOpen: true }))
      .on(this.close, (s) => ({ ...s, isOpen: false }))
  }
}

export const finishCallModalService = new FinishCallModalService()
